<template>
  <div :class="'t-table' + (currentExpand ? '' : ' no-expand')"  ref="TTable">
    <!--:height="tableHeight?tableHeight:tableAutoHeight"-->
    <!--:stripe="!currentExpand"-->
    <el-table
      :id="id"
      :highlight-current-row="highlightCurrentRow!==false?true:false"
      :data="tableDataWidhtOrder"
      ref="table"
      @select="select"
      @select-all="selectAll"
      @row-click="clickTr"
      @cell-click="clickTd"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      :row-class-name="tableRowClassName"
      :row-style="rowStyleCb"
      :height="height?height:(tableAutoHeight || undefined)"
      :border="border"
    >
      <!-- 复选框 -->
      <el-table-column v-if="_useSelection" type="selection" width="50px" :resizable="false">
      </el-table-column>
      <!--      <slot name="selection"></slot>-->
      <!-- 扩展列 -->
      <!-- <el-table-column type="expand" v-if="currentExpand" :resizable="false">
        <template slot-scope="props">
          <div
            v-for="(item,index) in tableProp"
            v-if="(!item.if || item.if(props.row)) && hideLevel.indexOf(newPropToLabel.length-index)>-1"
            :key="item.prop">
            <span style="color:#4da7e7">{{item.label}}：</span>
            <b style="color:#fff">{{item.formatter ? item.formatter(props.row) :
              props.row[item.prop]}}</b>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column type="expand" v-if="currentExpand" :resizable="false" width="20">
        <template slot-scope="props">
          <!-- subWidth:number  传值可以做到让某项单独占满一行  排版用  见车型不一致
          isColor:string   传值可以做到让某项的颜色改变 见车型不一致-->
          <div
            :style="{width:item.subWidth?item.subWidth+'px':''}"
            v-for="(item,index) in tableProp"
            v-if="item.hiddenCont!=true&&(!currentExpand || hideLevel.indexOf(newPropToLabel.length-index)<0)"
            :key="index">
            <span style="color:#4da7e7">{{item.label}}：</span>
            <b :style="{color:props.row[item.prop]&&item.isColor?item.isColor:'#fff',...(item.styles?item.styles(props.row):[])}">{{item.formatter ? item.formatter(props.row) :
              props.row[item.prop]?props.row[item.prop]:'--'}}</b>
          </div>
        </template>
      </el-table-column>
      <!-- 特殊列内容分发 -->
      <slot name="first"></slot>
      <!--
      特殊内容示例
          <template scope="scope" slot="frontCameraState">
              <span v-if="scope.row.frontCameraState==2" style="color:red">异常</span>
              <span v-else>正常</span>
          </template>
      -->
      <!-- 根据 propToLabel 循环出各列，-->
      <!-- expand: 当前是否需要扩展 -->
      <el-table-column
        :resizable="false"
        v-for="(item,index) in newPropToLabel" :key="item.prop" :prop="item.prop"
        :label="item.label" :sortable="item.sortable"
        v-if="(!currentExpand || hideLevel.indexOf(newPropToLabel.length-index)<0)&&!item.isHidden"
        :min-width="item.minWidth" :width="item.width"
        :align="item.align|| 'left'"
        :fixed="item.fixed">
        <template slot-scope="scope">
          <div v-if="item.slot">
            <slot :name="item.slot" :row="scope.row"></slot>
          </div>
          <div :style="{...(item.styles?item.styles(scope.row):[])}" v-else>{{item.formatter ? formatEmpty(item.formatter(scope.row)) :
            formatEmpty(scope.row[item.prop])}}
          </div>
        </template>
        <template slot="header" v-if="item.toastWords">
          <p>{{item.label}}
            <el-tooltip class="item" :content="item.toastWords" effect="dark" placement="top">
              <i style="display:inline-block;" class="el-icon-question questionMark"></i>
            </el-tooltip>
          </p>
        </template>
      </el-table-column>
      <!-- 特殊列内容分发 -->
      <slot name="last"></slot>
      <!-- 特殊列内容分发 -->
      <slot></slot>
      <base-empty slot="empty"></base-empty>
    </el-table>
  </div>
</template>
<style lang="scss" scoped>
/deep/ .el-table__empty-block{
  align-items: start;
}
  .t-table {
    height: 100%;
    &.no-expand {
      overflow: auto;

      .el-table__body-wrapper {
        overflow-x: auto;
      }
    }

    overflow: hidden;

    .el-table__body-wrapper {
      overflow-x: hidden;
    }

    .el-table__expand-icon {
      position: inherit;
    }

    .current-row {
      .btn {
        color: #FFF;
      }
    }

    .el-table__expanded-cell {
      background-color: #1d2d54;
      box-shadow: inset 0 2px 2px #072044;

      div {
        text-align: left;
        min-width: 300px;
        float: left;
        margin-right: 20px;

        .label {
          color: #162B96;
        }
      }

      &:hover {
        background-color: #17264c !important;
      }
    }

    .el-table__expand-icon {
      transform: none;

      .el-icon-arrow-right {
        transform: rotate(90deg);
      }
    }

    .el-table__expand-icon--expanded {
      transform: none;

      .el-icon-arrow-right {
        transform: rotate(-90deg);
      }
    }

    .current-row-color {
      /*background-color: #1A7CCF;*/
      color: #506181;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../../../src/business-components/table-pagination/components/table/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../../../src/business-components/table-pagination/components/table/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../../../src/business-components/table-pagination/components/table/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-private-table')
  export default {
    name: 'private-table', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'private-table': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../../../base-components/account-info/index.vue').default,
       'base-back': require('./../../../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../../../base-components/empty/index.vue').default,
       'base-export': require('./../../../../base-components/export/index.vue').default,
       'base-filter': require('./../../../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>